module.exports = __webpack_public_path__ + "media/flags/lr-4cf680b3.svg";